import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { RutasPrivadas } from "../routes/rutasPrivadas/rutasPrivadas";
import { AppStore } from "../store/store";
import { RutasPublicas } from "../routes/rutasPublicas/rutasPublicas";

interface Props {
    privateValidation: boolean;
  }

  const PrivateValidationFragment = <Outlet />;
  const PublicValidationFragment = <Navigate replace to={RutasPrivadas.PRIVATE} />;

  export const AuthGuard = ({ privateValidation }: Props) => {
    const tokenInStorage = useSelector((store: AppStore) => store.token);
    const redirect = !tokenInStorage || tokenInStorage.token === '';
    return redirect ? (
      <Navigate replace to={RutasPublicas.INICIO_SESION} />
    ) : (
      privateValidation ? (
        PrivateValidationFragment
      ) : (
        PublicValidationFragment
      )
    );
  };

  export default AuthGuard;
